export default __webpack_public_path__ + "static/media/TARA MOUTH1.038b7f19.png";